import { cn } from '@/lib/utils'

interface Props {
  receiptNumber: string
  recentlyUpdated?: boolean
  invalid?: boolean
}

export const CellContentCaseNumber = ({ receiptNumber, recentlyUpdated = false, invalid = false }: Props) => {
  return <div className={cn(recentlyUpdated && 'font-bold', invalid && 'text-red-500')}>{receiptNumber}</div>
}
